import { render, staticRenderFns } from "./DatePickerConfigView.vue?vue&type=template&id=445576dc&scoped=true"
import script from "./DatePickerConfigView.vue?vue&type=script&lang=js"
export * from "./DatePickerConfigView.vue?vue&type=script&lang=js"
import style0 from "./DatePickerConfigView.vue?vue&type=style&index=0&id=445576dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445576dc",
  null
  
)

export default component.exports